import {TrackingProduct} from '../../../types';
import {DetailedPageInfo} from './clientState';
import {DataLayerEvent} from './datalayer';
import {calcCentsToEuro} from './prices';
import {stringifyEventData} from './stringifyEventData';

export type CommonEventData = Pick<
  DataLayerEvent,
  'action' | 'label' | 'value'
>;

export function commonEventDataHandler({
  currentPage,
  product,
}: {
  currentPage: DetailedPageInfo;
  product: TrackingProduct;
}): CommonEventData {
  return {
    action: stringifyEventData([currentPage.page.type, currentPage.page.id]),
    label: `${product.id}`,
    value: calcCentsToEuro(product.minPrice.withoutTax).toFixed(2),
  };
}
